import { ScrollArea } from '@/components/ui/scroll-area';

const PrettyPrintJson = ({ data }: { data: any }) => {
  // (destructured) data could be a prop for example
  return (
    <ScrollArea className="flex max-h-96">
      <div>
        <pre>{JSON.stringify(data, null, 2)}</pre>
      </div>
    </ScrollArea>
  );
};
export default PrettyPrintJson;
